import { createContext, type FC } from 'react';
import identity from 'lodash/identity';
import type { IBreadcrumbItem } from 'dash-ui';

import { useBreadcrumbBuilder } from 'common/hooks/use-breadcrumb-builder';

import type {
  IBreadcrumbContext,
  IBreadcrumbProviderProps,
} from './breadcrumb-context.interfaces';

const defaultContextValue = {
  breadcrumbItems: [],
  setBreadcrumbItems: identity<IBreadcrumbItem[]>,
};

const BreadcrumbContext =
  createContext<IBreadcrumbContext>(defaultContextValue);

const BreadcrumbProvider: FC<IBreadcrumbProviderProps> = ({ children }) => {
  const [breadcrumbItems, setBreadcrumbItems] = useBreadcrumbBuilder();

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbItems, setBreadcrumbItems }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export { BreadcrumbContext, BreadcrumbProvider };
